import { render, staticRenderFns } from "./BillSharedList.vue?vue&type=template&id=983cd928"
import script from "./BillSharedList.vue?vue&type=script&lang=js"
export * from "./BillSharedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports